// Hilfsfunktionen zum Auslesen der Berechtigungs-Claims aus dem gespeicherten
// JWT. Zentral hier, da mehrere Seiten (Ergebniseingabe, Wettkampfbericht-
// Bestätigung) dieselbe Auswertung brauchen.

export function parseBerechtigungenFromToken() {
  try {
    const token = localStorage.getItem('authToken');
    if (!token) return [];
    const part = token.split('.')[1];
    if (!part) return [];
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const payload = JSON.parse(atob(padded));
    const raw = payload['berechtigung'];
    if (!raw) return [];
    const list = Array.isArray(raw) ? raw : [raw];
    return list.map(b => {
      const idx = b.indexOf(':');
      const rollenId = parseInt(b.slice(0, idx), 10);
      const vereinIdStr = b.slice(idx + 1);
      const vereinId = vereinIdStr ? parseInt(vereinIdStr, 10) : null;
      return { rollenId, vereinId };
    }).filter(b => !Number.isNaN(b.rollenId));
  } catch {
    return [];
  }
}
